<template>
  <teleport to="body">
    <transition name="modal">
      <div v-bind="$attrs" class="modal-mask">
        <div class="modal-wrapper">
          <slot name="container">
            <div class="modal-container">
              <div class="modal-header">
                <slot name="header"></slot>
              </div>

              <div class="modal-body">
                <slot name="body"></slot>
              </div>

              <div class="modal-footer">
                <slot name="footer">
                  <button class="btn btn-sandpiper" @click="$emit('close')">OK</button>
                </slot>
              </div>
            </div>
          </slot>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
  name: "VModal",
  emits: [ "close" ],
  inheritAttrs: false
}
</script>

<style lang="scss">
.modal-mask
{
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.85);
  display: table;
}

.modal-wrapper
{
  display: table-cell;
  vertical-align: middle;
}

.modal-container
{
  max-width: 400px;
  margin: 0 auto;
  padding: 25px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header
{
  border: none;
  padding: 0;

  h3
  {
    margin-top: 0;
    color: #082B42;
    font-size: 20px;
    font-weight: bold;
  }
}

.modal-body
{
  padding: 0;
}

.modal-footer
{
  border: none;
  padding: 0;
}

.modal-default-button
{
  display: block;
  margin-top: 1rem;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-active,
.modal-leave-active
{
  transition: opacity 0.5s ease;
}

.modal-enter-from,
.modal-leave-to
{
  opacity: 0;
}
</style>